import { h, Component } from 'preact';
import './index.less';
import SearchIcon from '../../molecules/Icon/Search';
import MultiplyIcon from '../../molecules/Icon/Multiply';
import { getCatalogueTheme } from '../../lib/Theme';
import {
  getSearchTerm,
  setSearchTerm,
  addSearchListener,
  addSearchStateListener,
  removeSearchStateListener,
  removeSearchListener,
  getSearchState,
  deactivateSearch,
  cancelSearchDebounce
} from '../../lib/Search';
import { showCreateFreeCatalogueBanner } from '../../lib/Amalgam';
import { NAVBAR_BANNER_HEIGHT } from '../../../config';
import I18n from '../../lib/I18n';
import EventBus from '../../lib/EventBus';
import { getPrimaryLoaderStyle, isLightColor } from '../../lib/Utils';
import { setNativeStatusBarColor } from '../../../../../nativeConnectors/platform';
import { getCurrentRouteName, NAME as ROUTE_NAME } from '../../lib/Route';

class NavBarSearchBar extends Component {
  constructor (props) {
    super(props);

    this.state = {
      searchState: getSearchState(),
      searchTerm: getSearchTerm(),
      searchInProgress: false
    };
  }

  componentDidMount () {
    addSearchStateListener(this.onSearchStateChange);
    addSearchListener(this.onSearchChange);
    EventBus.addListener(EventBus.TYPE.SEARCH_STARTED, this.onSearchStarted);
    EventBus.addListener(EventBus.TYPE.SEARCH_DONE, this.onSearchDone);
    window.addEventListener('popstate', this.onBackButtonPressClearSearch);
  }

  componentDidUpdate (previousProps, previousState) {
    if (!previousState.searchState && this.state.searchState && this.input) {
      setTimeout(() => {
        this.input.focus();
      });
    }
  }

  componentWillUnmount () {
    cancelSearchDebounce();
    removeSearchStateListener(this.onSearchStateChange);
    removeSearchListener(this.onSearchChange);
    EventBus.removeListener(EventBus.TYPE.SEARCH_STARTED, this.onSearchStarted);
    EventBus.removeListener(EventBus.TYPE.SEARCH_DONE, this.onSearchDone);
    window.removeEventListener('popstate', this.onBackButtonPressClearSearch);
  }

  onBackButtonPressClearSearch = () => {
    deactivateSearch(false);
    this.onSearchStateChange(null, false);
  };

  onSearchStateChange = (searchState, notify = true) => {
    this.setState({ searchState: getSearchState() }, () => {
      if (!notify) {
        return;
      }
      if (this.state.searchState) {
        history.pushState(null, '', window.location);
      } else {
        history.go(-1);
      }
    });
  };

  onSearchChange = () => {
    this.setState({ searchTerm: getSearchTerm() });
  };

  onSearchStarted = () => {
    this.setState({ searchInProgress: true });
  };

  onSearchDone = () => {
    this.setState({ searchInProgress: false });
  };

  onInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  onCloseClick = () => {
    deactivateSearch();
  };

  onClearClick = () => {
    setSearchTerm('');
  };

  onSearchSubmit = (e) => {
    e.preventDefault();

    if (this.input) {
      this.input.blur();
    }
  };

  onInputFocus = () => {
    setNativeStatusBarColor('#ffffff');
  };

  onInputBlur = () => {
    const { homeGrid } = getCatalogueTheme() || {};
    const { backgroundColor } = homeGrid || {};
    setNativeStatusBarColor(backgroundColor);
  };

  render () {
    const { searchState, searchTerm, searchInProgress } = this.state;

    const homepageTheme = getCatalogueTheme().homepage || {};
    const homegridTheme = getCatalogueTheme().homeGrid || {};

    if (!searchState) {
      return null;
    }

    const currentRoute = getCurrentRouteName();

    return (
      <div
        className={`nav-bar-search-bar ${homegridTheme.searchClass}`}
        style={{
          backgroundColor:
            currentRoute === ROUTE_NAME.GALLERY ||
            currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_GALLERY
              ? homepageTheme.collapsedHeaderBackground
              : homegridTheme.backgroundColor,
          top: showCreateFreeCatalogueBanner() ? NAVBAR_BANNER_HEIGHT : 0
        }}
      >
        <div className="bar">
          <div className="close-icon" onClick={this.onCloseClick}>
            <MultiplyIcon
              color={
                homegridTheme.searchClass === 'dark'
                  ? '#fff'
                  : homegridTheme.searchIconColor || '#3833EA'
              }
              size={12}
            />
          </div>

          <form action="." className="search-input-container" onSubmit={this.onSearchSubmit}>
            <input
              ref={(element) => (this.input = element)}
              type="search"
              style={{
                color: isLightColor(homegridTheme.backgroundColor) ? '#000' : '#FFF'
              }}
              placeholder={I18n.t('SEARCH_FOR_PRODUCTS')}
              value={searchTerm}
              onInput={this.onInputChange}
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
            />
          </form>

          <div className="search-icon" onClick={this.onSearchSubmit}>
            {searchInProgress ? (
              <div className="search-loader">
                <div className="loader" style={getPrimaryLoaderStyle()} />
              </div>
            ) : (
              <SearchIcon
                color={
                  homegridTheme.searchClass === 'dark' ? '#fff' : homegridTheme.searchIconColor
                }
                size={18}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default NavBarSearchBar;
